import { pick, getRowId, getRowName } from "./masterDataUtils";

/* Qualification slot ids, as the API defines them. Not employee data. */
const QUALIFICATION_TYPE = { NON_TECHNICAL: 1, PROFESSIONAL: 2, TECHNICAL: 3 };


const K = {
  id: ["HedEmployeeId", "EmployeeId", "hedEmployeeId", "employeeId", "Id", "id", "HED_EMPLOYEE_ID"],
  serviceNo: ["HedServiceNo", "ServiceNo", "hedServiceNo", "serviceNo", "HED_SERVICE_NO"],
  epfNo: ["HedEpfNo", "EpfNo", "epfNo", "HED_EPF_NO"],
  etfNo: ["HedEtfNo", "EtfNo", "etfNo", "HED_ETF_NO"],
  tinNo: ["HedTinNo", "TinNo", "tinNo", "p_TinNo", "HED_TIN_NO"],
  distance: ["HedDistance", "Distance", "distance", "p_Distance", "HED_DISTANCE"],
  title: ["HedTitle", "Title", "title", "HED_TITLE"],
  firstName: ["HedFirstName", "FirstName", "firstName", "HED_FIRST_NAME"],
  middleName: ["HedMiddleName", "MiddleName", "middleName", "HED_MIDDLE_NAME"],
  lastName: ["HedLastName", "LastName", "lastName", "HED_LAST_NAME"],
  initials: ["HedInitials", "Initials", "initials", "HED_INITIALS"],
  reportName: ["HedReportName", "ReportName", "reportName", "HED_REPORT_NAME"],
  gender: ["HedGender", "Gender", "gender", "HED_GENDER"],
  dateOfBirth: ["HED_DATE_OF_BIRTH", "HedDateOfBirth", "DateOfBirth", "dateOfBirth", "HED_DATE_OF_BIRTH"],
  nicNo: ["HedNicNo", "NicNo", "nicNo", "HED_NIC_NO"],
  passportNo: ["HedPassportNo", "PassportNo", "passportNo", "HED_PASSPORT_NO"],
  maritalStatus: ["HedMaritalStatus", "MaritalStatus", "maritalStatus", "HED_MARITAL_STATUS"],
  religion: ["HedReligion", "Religion", "religion", "HED_RELIGION"],
  nationality: ["HedNationality", "Nationality", "nationality", "HED_NATIONALITY"],
  bloodGroup: ["HedBloodGroup", "BloodGroup", "bloodGroup", "HED_BLOOD_GROUP"],
  mobileNo: ["HedMobileNo", "MobileNo", "mobileNo", "HED_MOBILE_NO"],
  homeNo: ["HedHomeNo", "HomeNo", "homeNo", "HED_HOME_NO"],
  officeNo: ["HedOfficeNo", "OfficeNo", "officeNo", "HED_OFFICE_NO"],
  personalEmail: ["HedPersonalEmail", "PersonalEmail", "personalEmail", "HED_PERSONAL_EMAIL"],
  companyEmail: ["HedCompanyEmail", "CompanyEmail", "companyEmail", "HED_COMPANY_EMAIL"],
  departmentId: ["HedDepartmentId", "DepartmentId", "departmentId", "HED_DEPARTMENT_ID"],
  locationId: ["HED_LOCATION_ID", "HedLocationId", "LocationId", "locationId", "HED_LOCATION_ID"],
  designationId: ["HedDesignationId", "DesignationId", "designationId", "HED_DESIGNATION_ID"],
  gradeId: ["HedGradeId", "GradeId", "gradeId", "HED_GRADE_ID"],
  employmentCategoryId: ["HedEmploymentCategoryId", "EmploymentCategoryId", "employmentCategoryId", "HED_EMPLOYMENT_CATEGORY_ID"],
  shiftId: ["HED_SHIFT_ID", "HedShiftId", "ShiftId", "shiftId", "HED_SHIFT_ID"],
  dateOfJoining: ["HED_DATE_OF_JOINING", "HedDateOfJoining", "DateOfJoining", "dateOfJoining", "HED_DATE_OF_JOINING"],
  confirmationDate: ["HedConfirmationDate", "ConfirmationDate", "confirmationDate", "HED_CONFIRMATION_DATE"],
  noticePeriodDays: ["HedNoticePeriodDays", "NoticePeriodDays", "noticePeriodDays", "HED_NOTICE_PERIOD_DAYS"],
  reportingEmployeeId: ["HedReportingEmployeeId", "ReportingEmployeeId", "reportingEmployeeId", "HED_REPORTING_EMPLOYEE_ID"],
  isSystemUser: ["HedIsSystemUser", "IsSystemUser", "isSystemUser", "HED_IS_SYSTEM_USER"],
  isActive: ["HedIsActive", "IsActive", "isActive", "HED_IS_ACTIVE"],
  remarks: ["HedRemarks", "Remarks", "remarks", "HED_REMARKS"],
  // in case the backend already joins these in the list response
  departmentName: ["DepartmentName", "departmentName"],
  designationName: ["DesignationName", "designationName"],
  gradeName: ["GradeName", "gradeName"],
  locationName: ["LocationName", "locationName"],
  employmentCategoryName: ["EmploymentCategoryName", "employmentCategoryName"],
  shiftName: ["ShiftName", "shiftName"],

  addressId: ["HEA_ADDRESS_ID", "HeaAddressId", "AddressId", "addressId"],
  addressType: ["HEA_ADDRESS_TYPE", "HeaAddressType", "AddressType", "addressType"],
  addressLine1: ["HEA_ADDRESS_LINE1", "AddressLine1", "addressLine1"],
  addressLine2: ["HEA_ADDRESS_LINE2", "AddressLine2", "addressLine2"],
  addressLine3: ["HEA_ADDRESS_LINE3", "AddressLine3", "addressLine3"],
  city: ["HEA_CITY", "City", "city"],
  districtId: ["HEA_DISTRICT_ID", "HeaDistrictId", "DistrictId", "districtId"],
  provinceId: ["HEA_PROVINCE_ID", "HeaProvinceId", "ProvinceId", "provinceId"],
  countryId: ["HEA_COUNTRY_ID", "HeaCountryId", "CountryId", "countryId"],
  postalCode: ["HEA_POSTAL_CODE", "PostalCode", "postalCode"],
  
  bankId: ["HedBankId", "BankId", "hedBankId", "bankId", "HEB_BANK_ID"],
  branchId: ["HEB_BRANCH_ID", "BranchId", "branchId"],
  bankAccountName: ["HEB_ACCOUNT_NAME", "AccountName", "accountName"],
  bankAccountNumber: ["HedBankAccountNumber", "BankAccountNumber", "AccountNumber", "bankAccountNumber", "accountNumber", "HEB_ACCOUNT_NUMBER"],
  bankAccountType: ["HEB_ACCOUNT_TYPE", "AccountType", "accountType"],
  bankBranchCode: ["HedBankBranchCode", "BankBranchCode", "BranchCode", "Branch", "bankBranchCode", "branchCode"],

  costCenter: ["HED_COSTCENTER", "HedCostCenter", "CostCenter", "costCenter"],
  group: ["HED_GROUP", "HedGroup", "Group", "group"],
  totalExperience: ["HED_TOTAL_EXPERIANCE", "HED_TOTAL_EXPERIENCE", "HedTotalExperience", "TotalExperience", "totalExperience"],

  contactName: ["HEC_CONTACT_NAME", "HecContactName", "ContactName", "contactName"],
  contactRelationship: ["HEC_RELATIONSHIP", "HecRelationship", "Relationship", "contactRelationship"],
  contactNumber: ["HEC_CONTACT_NUMBER", "HecContactNumber", "ContactNumber", "contactNumber"],

  qualificationId: ["HEQ_QUALIFICATION_ID", "HeqQualificationId", "QualificationId", "qualificationId"],
  qualificationTypeId: ["HEQ_QUALIFICATION_TYPE_ID", "HeqQualificationTypeId", "qualificationTypeId"],
  qualificationName: ["HEQ_QUALIFICATION_NAME", "HeqQualificationName", "QualificationName", "qualificationName"],
};

const toDateInput = (value) => {
  if (!value) return "";
  const str = String(value);
  // Handles both "2024-01-15" and "2024-01-15T00:00:00" style values
  // return str.length >= 10 ? str.slice(0, 10) : str;

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

// Age in completed years, calculated from a "YYYY-MM-DD" date-of-birth value
// against today's date (not just year subtraction - accounts for whether
// this year's birthday has passed yet).
const calculateAge = (dobStr) => {
  if (!dobStr) return "";
  const dob = new Date(dobStr);
  if (Number.isNaN(dob.getTime())) return "";
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age -= 1;
  }
  if (age < 0 || age > 130) return "";
  return `${age} yrs`;
};

// Years (and months) of service, calculated from the date-of-joining value
// against today's date.
const calculateYearsOfService = (joinDateStr) => {
  if (!joinDateStr) return "";
  const join = new Date(joinDateStr);
  if (Number.isNaN(join.getTime())) return "";
  const today = new Date();
  if (join > today) return "Not yet joined";

  let years = today.getFullYear() - join.getFullYear();
  let months = today.getMonth() - join.getMonth();
  if (today.getDate() < join.getDate()) months -= 1;
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  if (years <= 0 && months <= 0) return "Less than a month";
  const parts = [];
  if (years > 0) parts.push(`${years} yr${years > 1 ? "s" : ""}`);
  if (months > 0) parts.push(`${months} mo${months > 1 ? "s" : ""}`);
  return parts.join(" ");
};

const isActiveValue = (raw) => {
  if (raw === undefined || raw === null || raw === "") return true;
  if (typeof raw === "string") return raw === "1" || raw.toLowerCase() === "true";
  if (typeof raw === "number") return raw === 1;
  return Boolean(raw);
};

const decode = (code, map) => {
  if (code === undefined || code === null || code === "") return "-";
  if (map && map[code] !== undefined) return map[code];
  return String(code);
};

const findAddress = (addresses, type) => 
(addresses || []).find((a) => pick(a, K.addressType) === type) || null;

const formatAddress = (addr) => {
  if (!addr) return "";
  return [
    pick(addr, K.addressLine1),
    pick(addr, K.addressLine2),
    pick(addr, K.addressLine3),
    pick(addr, K.city),
    pick(addr, K.postalCode),
  ]
  .filter(Boolean).join(", ");
}

const mapQualifications = (qualifications) => {
  const byType = { 
    nonTechnical: { id: null, name: "" }, 
    professional: { id: null, name: "" }, 
    technical: { id: null, name: "" }, 
  };

  (qualifications || []).forEach((q) => {
    const typeId = Number(pick(q, K.qualificationTypeId));
    const name = pick(q, K.qualificationName) || "";
    const id = pick(q, K.qualificationId) || null;
    if (typeId === QUALIFICATION_TYPE.NON_TECHNICAL) byType.nonTechnical = { id, name };
    else if (typeId === QUALIFICATION_TYPE.PROFESSIONAL) byType.professional = { id, name };
    else if (typeId === QUALIFICATION_TYPE.TECHNICAL) byType.technical = { id, name };
  });
  return byType;
}

/**
 * Normalize one GetEmployees row plus the current master-data lists into the
 * flat shape used by the table and EmployeeProfileDialog (name, empNo,
 * designation, department, ...). `codeMaps` decodes short codes (gender,
 * marital status, religion, nationality, blood group) into readable labels -
 * pass the same static option lists used to build the Add/Edit form dropdowns.
 */
export const mapEmployeeRow = (row, lookups = {}, codeMaps = {}) => {
  const { departmentById = {}, designationById = {}, gradeById = {}, locationById = {}, categoryById = {}, shiftById = {}, bankById = {}, branchById = {}, } = lookups;
  const { gender: genderMap, maritalStatus: maritalMap, religion: religionMap, nationality: nationalityMap, bloodGroup: bloodGroupMap } = codeMaps;

  const firstName = pick(row, K.firstName);
  const lastName = pick(row, K.lastName);
  const reportName = pick(row, K.reportName) || [firstName, lastName].filter(Boolean).join(" ");
  const departmentId = pick(row, K.departmentId);
  const designationId = pick(row, K.designationId);
  const gradeId = pick(row, K.gradeId);
  const locationId = pick(row, K.locationId);
  const categoryId = pick(row, K.employmentCategoryId);
  const shiftId = pick(row, K.shiftId);
  const bankId = pick(row, K.bankId);
  const branchId = pick(row, ["HEB_BRANCH_ID", "BranchId", "branchId"]);

  const addresses = row._Addresses || row.Addresses || [];
  const qualifications = row._Qualifications || row.Qualifications || [];
  const permanentAddress = findAddress(addresses, "P");
  const currentAddress = findAddress(addresses, "C");
  const qualByType = mapQualifications(qualifications);

  const dob = toDateInput(pick(row, K.dateOfBirth));
  const joinDate = toDateInput(pick(row, K.dateOfJoining));
  const locationName = pick(row, K.locationName) || getRowName(locationById[locationId] || {}) || "-";

  // const addressType = pick(row, K.addressType);

  const address = [
    pick(row, K.addressLine1),
    pick(row, K.addressLine2),
    pick(row, K.addressLine3),
    pick(row, K.postalCode),
  ].filter(Boolean).join(", ");

  console.log({
  employeeBranchId: branchId,
  branchLookup: branchById[branchId],
  allBranches: branchById,
});

  return {
    id: pick(row, K.id),
    empNo: pick(row, K.serviceNo),
    name: reportName || "-",
    gender: decode(pick(row, K.gender), genderMap),
    dob,
    age: calculateAge(dob),
    mobile: pick(row, K.mobileNo),
    contact: pick(row, K.mobileNo),
    maritalStatus: decode(pick(row, K.maritalStatus), maritalMap),
    religion: decode(pick(row, K.religion), religionMap),
    nationality: decode(pick(row, K.nationality), nationalityMap),
    bloodGroup: decode(pick(row, K.bloodGroup), bloodGroupMap),
    nic: pick(row, K.nicNo),
    epfNo: pick(row, K.epfNo),
    designation: pick(row, K.designationName) || getRowName(designationById[designationId] || {}) || "-",
    department: pick(row, K.departmentName) || getRowName(departmentById[departmentId] || {}) || "-",
    location: locationName,
    // Cost Center is also resolved from HED_LOCATION_ID via the Locations
    // master list (GetLocations) - same decode as Location, shown separately
    // since both are expected on the profile.
    // costCenter: locationName,

    costCenter: pick(row, K.costCenter) || "-",
    // address,
    // addressType, 
    address: formatAddress(permanentAddress) || formatAddress(currentAddress),
    addressType: permanentAddress ? "P" : currentAddress ? "C" : null,
    permanentAddress: formatAddress(permanentAddress),
    currentAddress: formatAddress(currentAddress),

    group: pick(row, K.group) || "-",
    totalExperience: pick(row, K.totalExperience) || "-",

    contactName: pick(row, K.contactName) || "-",
    contactRelationship: pick(row, K.contactRelationship) || "-",
    contactNumber: pick(row, K.contactNumber) || "-",

    companyEmail: pick(row, K.companyEmail) || "-",

    // qualificationTypeId: pick(row, K.qualificationTypeId),
    // qualificationName: pick(row, K.qualificationName) || "-",

    qualificationName: qualByType.nonTechnical.name || "-",
    nonTechnicalQualificationName: qualByType.nonTechnical.name || "-",
    professionalQualificationName: qualByType.professional.name || "-",
    technicalQualificationName: qualByType.technical.name || "-",

    grade: pick(row, K.gradeName) || getRowName(gradeById[gradeId] || {}) || "-",
    employmentCategory: pick(row, K.employmentCategoryName) || getRowName(categoryById[categoryId] || {}) || "-",
    shift: pick(row, K.shiftName) || getRowName(shiftById[shiftId] || {}) || "-",
    bankName: getRowName(bankById[bankId] || {}, ["HBD_BANK_NAME", "BankName", "bankName"]) || "-",
    accountNumber: pick(row, K.bankAccountNumber) || "-",
    // branch: pick(row, K.bankBranchCode) || "-",
    branch: getRowName(
      branchById[branchId] || {},
      ["HBB_BRANCH_NAME", "BranchName", "branchName"]
    ) || "-",
    branchCode: getRowName(
      branchById[branchId] || {},
      ["HBB_BRANCH_CODE", "BranchCode", "branchCode"]
    ),
    joinDate,
    yearsOfService: calculateYearsOfService(joinDate),
    noticePeriod: pick(row, K.noticePeriodDays) ? `${pick(row, K.noticePeriodDays)} days` : "",
    reportingStaffId: pick(row, K.reportingEmployeeId),
    reportingTo: "-", // resolved to a name in a second pass once the full employee list is available
    
    status: isActiveValue(pick(row, K.isActive, true)) ? "Active" : "Inactive",
    _raw: row,
    _addressRaw: addresses,
    _qualificationsRaw: qualifications,
    _departmentId: departmentId,
    _designationId: designationId,
    _gradeId: gradeId,
    _locationId: locationId,
    _employmentCategoryId: categoryId,
    _shiftId: shiftId,

    _permanentAddressId: pick(permanentAddress || {}, K.addressId) || null,
    _currentAddressId: pick(currentAddress || {}, K.addressId) || null,
    _nonTechnicalQualificationId: qualByType.nonTechnical.id,
    _professionalQualificationId: qualByType.professional.id,
    _technicalQualificationId: qualByType.technical.id,
  };
};

/** Build the id -> row lookup maps used above, from each master-data list. */
export const buildLookups = ({ departments, designations, grades, locations, categories, shifts, banks, branches }) => {
  const toMap = (list, idKeys) => {
    const map = {};
    (list || []).forEach((row) => {
      map[getRowId(row, idKeys)] = row;
    });
    return map;
  };
  return {
    departmentById: toMap(departments, ["DepartmentId", "departmentId"]),
    designationById: toMap(designations, ["DesignationId", "designationId"]),
    gradeById: toMap(grades, ["GradeId", "gradeId"]),
    locationById: toMap(locations, ["LocationId", "locationId"]),
    categoryById: toMap(categories, ["CategoryId", "categoryId"]),
    shiftById: toMap(shifts, ["ShiftId", "shiftId"]),
    bankById: toMap(banks, ["HBD_BANK_ID", "BankId", "bankId"]),
    branchById: toMap(branches, ["HBB_BRANCH_ID", "BranchId", "branchId"]),
  };
};

/** Turn the Add/Edit Employee form values into the exact p_hed* payload the API expects. */
export const buildEmployeePayload = (values, { isUpdate, employeeId, currentUser }) => {
  const base = {
    p_hedServiceNo: values.serviceNo || "",
    p_hedEpfNo: values.epfNo || "",
    p_hedEtfNo: values.epfNo || "",
    p_hedTitle: values.title || "",
    p_hedFirstName: values.firstName || "",
    p_hedMiddleName: values.middleName || "",
    p_hedLastName: values.lastName || "",
    p_hedInitials: values.initials || "",
    p_hedReportName: values.reportName || "",
    p_hedGender: values.gender || "",
    p_hedDateOfBirth: values.dateOfBirth || "",
    p_hedNicNo: values.nicNo || "",
    p_hedPassportNo: values.passportNo || "",
    p_hedMaritalStatus: values.maritalStatus || "",
    p_hedReligion: values.religion || "",
    p_hedNationality: values.nationality || "",
    p_hedBloodGroup: values.bloodGroup ? Number(values.bloodGroup) : null,
    p_hedMobileNo: values.mobileNo || "",
    p_hedHomeNo: values.homeNo || "",
    p_hedOfficeNo: values.officeNo || "",
    p_hedPersonalEmail: values.personalEmail || "",
    p_hedCompanyEmail: values.companyEmail || "",
    p_hedDepartmentId: values.departmentId || null,
    p_hedLocationId: values.locationId || null,
    p_hedDesignationId: values.designationId || null,
    p_hedGradeId: values.gradeId || null,
    p_hedEmploymentCategoryId: values.employmentCategoryId || null,
    p_hedShiftId: values.shiftId || null,
    p_hedDateOfJoining: values.dateOfJoining || "",
    p_hedConfirmationDate: values.confirmationDate || "",
    p_hedNoticePeriodDays: values.noticePeriodDays ? Number(values.noticePeriodDays) : null,
    p_hedRemarks: values.remarks || "",
    p_hedReportingEmployeeId: values.reportingEmployeeId || null,
    p_hedGroup: values.group || "",
    p_hedCostCenter: values.costCenter || "",
    p_hedTotalExperiance: values.totalExperience || "",

    // p_hedIsSystemUser: values.isSystemUser || "",
    // p_hedCreatedBy: values.hedCreatedBy || "",
    // p_hedIsActive: "",

    // -- Permanent address only. Current address is upserted separately.
    // p_heaAddressType: "P",
    // p_heaAddressLine1: values.permanentAddressLine1 || "",
    // p_heaAddressLine2: values.permanentAddressLine2 || "",
    // p_heaAddressLine3: values.permanentAddressLine3 || "",
    // p_heaCity: values.permanentAddressCity || "",
    // p_heaPostalCode: values.postalCode || "",

    // p_heaDistrictID: 2, //values.districtId || null,
    // p_heaProvinceId: 2, // values.provinceId || null,
    // p_heaCountryId: 1, // values.countryId || null,

    // // --- backend defaults ---
    // p_heaIsPrimary: true,
    // p_heaCreatedBy: currentUser,
    // p_heaIsActive: true,
    // p_heaRemarks: values.heaRemarks || "",
    // ------------------------

    p_hebBankId: values.bankId || null,
    p_hebBranchID: values.branchId || null,
    p_hebAccountName: values.accountName || "",
    p_hebAccountNumber: values.accountNumber || "",
    p_hebAccountType: values.accountType || "Current",

    // --- backend defaults ---
    p_hebIsPrimary: true,
    p_hebCreatedBy: currentUser,
    p_hebIsActive: true,
    p_hebRemarks: values.bankRemarks || "",
    // -- OT RATE ---
    p_OT: 225,
    // ------------------------

    // -- Emergency contact --
    p_hecContactName: values.altContactName || "",
    p_hecContactNumber: values.altContactNumber || "",
    p_hecRelationship:  values.altContactRelationship || "",
    p_hecContactType: "Emergency",
    p_hecAddress: values.permanentAddressLine1 || "",
    p_hecCreatedBy: currentUser,
    p_hecIsActive: true,
    p_hecRemarks: "",
  };

  if (isUpdate) {
    return {
      p_hedEmployeeId: employeeId,
      ...base,
      p_hedIsSystemUser: Boolean(values.isSystemUser),
      p_hedUpdatedBy: currentUser,
      p_hedIsActive: values.status !== "Inactive",
    };
  }

  return {
    ...base,
    p_hedCreatedBy: currentUser,
  };
};

export const EMPTY_EMPLOYEE_FORM = {
  serviceNo: "",
  epfNo: "",
  etfNo: "",
  tinNo: "",
  distance: "",
  title: "",
  firstName: "",
  middleName: "",
  lastName: "",
  initials: "",
  reportName: "",
  gender: "",
  dateOfBirth: "",
  nicNo: "",
  passportNo: "",
  maritalStatus: "",
  religion: "",
  nationality: "",
  bloodGroup: "",
  mobileNo: "",
  homeNo: "",
  officeNo: "",
  personalEmail: "",
  companyEmail: "",
  departmentId: "",
  locationId: "",
  designationId: "",
  gradeId: "",
  employmentCategoryId: "",
  shiftId: "",
  dateOfJoining: "",
  confirmationDate: "",
  noticePeriodDays: "",
  remarks: "",
  reportingEmployeeId: "",

  addressType: "C",
  addressLine1: "",
  addressLine2: "",
  addressLine3: "",
  city: "",
  districtId: "",
  provinceId: "",
  countryId: "",
  postalCode: "",
  addressRemarks: "",

  bankId: "",
  branchId: "",
  accountName: "",
  accountNumber: "",
  accountType: "",
  bankRemarks: "",
 
  isSystemUser: false,
  status: "Active",

  permanentAddressLine1: "",
  permanentAddressLine2: "",
  permanentAddressLine3: "",
  permanentAddressCity: "",

  currentAddressLine1: "",
  currentAddressLine2: "",
  currentAddressLine3: "",
  currentAddressCity: "",

  altContactName: "",
  altContactRelationship: "",
  altContactNumber: "",

  costCenter: "",
  group: "",
  totalExperience: "",

  nonTechnicalQualification: "",
  professionalQualification: "",
  technicalQualification: "",

  permanentAddressId: null,
  currentAddressId: null,
  nonTechnicalQualificationId: null,
  professionalQualificationId: null,
  technicalQualificationId: null,
};

/**
 * Map a normalized row (from mapEmployeeRow) back into edit-form field values.
 * Codes (gender/maritalStatus/religion/nationality/bloodGroup/shiftId) are
 * re-read straight from the original raw API row (row._raw) rather than
 * reverse-decoded from the display label, since that's exact and doesn't
 * depend on the label wording matching.
 */
export const employeeRowToFormValues = (row) => {
  const raw = row._raw || {};
  const addresses = row._addressRaw || [];
  const permanentAddress = findAddress(addresses, "P");
  const currentAddress = findAddress(addresses, "C");

  return {
    ...EMPTY_EMPLOYEE_FORM,
    serviceNo: row.empNo || "",
    epfNo: row.epfNo || "",
    etfNo: pick(raw, K.etfNo),
    tinNo: pick(raw, K.tinNo),
    distance: pick(raw, K.distance),
    title: pick(raw, K.title),
    firstName: pick(raw, K.firstName),
    middleName: pick(raw, K.middleName),
    lastName: pick(raw, K.lastName),
    initials: pick(raw, K.initials),
    nicNo: row.nic || "",
    passportNo: pick(raw, K.passportNo),
    mobileNo: row.mobile || "",
    homeNo: pick(raw, K.homeNo),
    officeNo: pick(raw, K.officeNo),
    personalEmail: pick(raw, K.personalEmail),
    companyEmail: pick(raw, K.companyEmail),
    maritalStatus: pick(raw, K.maritalStatus),
    religion: pick(raw, K.religion),
    nationality: pick(raw, K.nationality),
    bloodGroup: pick(raw, K.bloodGroup) || "",
    gender: pick(raw, K.gender),
    dateOfBirth: row.dob || "",
    departmentId: row._departmentId || "",
    designationId: row._designationId || "",
    gradeId: row._gradeId || "",
    locationId: row._locationId || "",
    employmentCategoryId: row._employmentCategoryId || "",
    shiftId: row._shiftId || "",
    dateOfJoining: row.joinDate || "",
    confirmationDate: toDateInput(pick(raw, K.confirmationDate)),
    reportingEmployeeId: row.reportingStaffId || "",
    reportName: row.name || "",
    status: row.status || "Active",
    noticePeriodDays: (row.noticePeriod || "").replace(/\D/g, ""),
    remarks: pick(raw, K.remarks),

    addressType: pick(currentAddress || {}, K.addressType) || "C",
    addressLine1: pick(currentAddress || {}, K.addressLine1),
    addressLine2: pick(currentAddress || {}, K.addressLine2),
    addressLine3: pick(currentAddress || {}, K.addressLine3),
    city: pick(currentAddress || {}, K.city),
    districtId: pick(currentAddress || {}, K.districtId),
    provinceId: pick(currentAddress || {}, K.provinceId),
    countryId: pick(currentAddress || {}, K.countryId),
    postalCode: pick(currentAddress || {}, K.postalCode),

    permanentAddressLine1: pick(permanentAddress || {}, K.addressLine1),
    permanentAddressLine2: pick(permanentAddress || {}, K.addressLine2),
    permanentAddressLine3: pick(permanentAddress || {}, K.addressLine3),
    permanentAddressCity: pick(permanentAddress || {}, K.city),

    // Current Address isn't in GetEmployees yet - left blank on edit for now
    currentAddressLine1: pick(currentAddress || {}, K.addressLine1),
    currentAddressLine2: pick(currentAddress || {}, K.addressLine2),
    currentAddressLine3: pick(currentAddress || {}, K.addressLine3),
    currentAddressCity: pick(currentAddress || {}, K.city),

    altContactName: pick(raw, ["HecContactName", "ContactName", "altContactName"]),
    altContactRelationship: pick(raw, ["HecRelationship", "Relationship", "altContactRelationship"]),
    altContactNumber: pick(raw, ["HecContactNumber", "ContactNumber", "altContactNumber"]),

    costCenter: pick(raw, K.costCenter),
    group: pick(raw, K.group),
    totalExperience: pick(raw, K.totalExperience),

    nonTechnicalQualification: row.nonTechnicalQualificationName !== "-" ? row.nonTechnicalQualificationName : "",
    professionalQualification: row.professionalQualificationName !== "-" ? row.professionalQualificationName : "",
    technicalQualification: row.technicalQualificationName !== "-" ? row.technicalQualificationName : "",

    permanentAddressId: row._permanentAddressId || null,
    currentAddressId: row._currentAddressId || null,
    nonTechnicalQualificationId: row._nonTechnicalQualificationId || null,
    professionalQualificationId: row._professionalQualificationId || null,
    technicalQualificationId: row._technicalQualificationId || null,

    // city: pick(raw, K.city),
    // districtId: pick(raw, K.districtId),
    // provinceId: pick(raw, K.provinceId),
    // countryId: pick(raw, K.countryId),
    // postalCode: pick(raw, K.postalCode),

    bankId: pick(raw, K.bankId),
    // branchId: pick(raw, K.branchId),
    branchId: pick(raw, ["HEB_BRANCH_ID", "BranchId", "branchId"]) || "",
    accountName: pick(raw, K.bankAccountName),
    accountNumber: pick(raw, K.bankAccountNumber),
    accountType: pick(raw, K.bankAccountType),  

    isSystemUser: (() => {
      const v = pick(raw, K.isSystemUser, false);
      if (typeof v === "string") return v === "1" || v.toLowerCase() === "true";
      return Boolean(v);
    })(),
  };
};